import axios from "axios";
import api from "../api";
import store from "@/store";
import filter_service from "./filter-service";
import moment from "moment";
moment.locale("pt-br");

async function destroy(prod) {
  return new Promise(async (resolve, reject) => {
    axios
      .post(`${api.kit_sizer.kit_editor}/${prod.optional_id}/remove_product`, {
        product_id: prod.id,
      })
      .then((response) => {
        resolve({
          ...response,
          data: {
            ...response.data,
            products: response.data.products.map((product) => {
              return {
                ...product,
                supply_date: !!product.supply_date
                  ? moment(product.supply_date).format("DD/MM/YYYY")
                  : null,
              };
            }),
          }
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function addProductToKit(params) {
  return new Promise(async (resolve, reject) => {
    axios
      .post(`${api.kit_sizer.kit_editor}/${params.kit_id}/add_product`, {
        product_id: params.product_id,
        quantity: params.quantity,
        supplier_id: params.supplier_id ? params.supplier_id.id : null,
      })
      .then((response) => {
        store.dispatch("alerts/success", "Produto adicionado ao kit");
        resolve({
          ...response.data,
          products: response.data.products.map((product) => {
            return {
              ...product,
              supply_date: !!product.supply_date
                ? moment(product.supply_date).format("DD/MM/YYYY")
                : null,
            };
          }),
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function resizeKit(params) {
  return new Promise(async (resolve, reject) => {
    axios
      .post(`${api.kit_sizer.kit_editor}/${params.kit_id}/adjust_products`)
      .then((response) => {
        let r = {
          ...response.data,
          products: response.data.products.map((product) => {
            return {
              ...product,
              supply_date: !!product.supply_date
                ? moment(product.supply_date).format("DD/MM/YYYY")
                : null,
            };
          }),
        };
        resolve(r);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getAvailableProducts(params) {
  let filter_params = filter_service.filter_params(params.filter);
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${api.kit_sizer.products}/${params.kit_id}/available_products${filter_params}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  destroy,
  addProductToKit,
  resizeKit,
  getAvailableProducts,
};
